import { get, post, put, del } from './_httpClient';

// --- Master sections (katalog tahapan/stage per program, dipakai lintas batch) ---

export async function getMasterProgramSections({ thirdTierProgramId }) {
  const { status, message, data } = await get(
    `/clp/program-sections/master?thirdTierProgramId=${thirdTierProgramId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addMasterProgramSection({ thirdTierProgramId, title, descriptions }) {
  const { status, message, data } = await post('/clp/program-sections/master', {
    thirdTierProgramId,
    title,
    descriptions,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateMasterProgramSection({ id, title, descriptions }) {
  const { status, message } = await put(`/clp/program-sections/master/${id}`, {
    title,
    descriptions,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
}

export async function deleteMasterProgramSection({ id, isForce = false }) {
  const query = isForce ? '?isForce=true' : '';
  const { status, message, canForce, details } = await del(
    `/clp/program-sections/master/${id}${query}`,
  );
  if (status !== 'success') {
    const error = new Error(message);
    error.canForce = canForce;
    error.details = details;
    throw error;
  }
}

export async function reorderMasterProgramSections({ thirdTierProgramId, orderedIds }) {
  const { status, message } = await put('/clp/program-sections/master/reorder', {
    thirdTierProgramId,
    orderedIds,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
}

// --- Timeline Program (jadwal per batch: tahapan + tanggal mulai/selesai) ---

export async function getProgramBatchSectionsForManagement({ batchId }) {
  const { status, message, data } = await get(`/clp/program-sections/batch/${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addProgramBatchSection({
  batchId, programSectionsId, startDate, endDate,
}) {
  const { status, message, data } = await post('/clp/program-sections/batch', {
    batchId,
    programSectionsId,
    startDate,
    endDate,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateProgramBatchSection({ id, startDate, endDate }) {
  const { status, message } = await put(`/clp/program-sections/batch/${id}`, {
    startDate,
    endDate,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
}

export async function deleteProgramBatchSection({ id }) {
  const { status, message } = await del(`/clp/program-sections/batch/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
}

// Menandai sebuah tahapan master sengaja TIDAK dipakai pada batch ini (beda
// batch bisa beda timeline) — berbeda dari "belum dijadwalkan", yang masih
// menyiratkan pekerjaan tertunda.
export async function excludeProgramBatchSection({ batchId, programSectionsId, batchSectionId }) {
  const { status, message, data } = await post('/clp/program-sections/batch/exclude', {
    batchId,
    programSectionsId,
    batchSectionId,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
